import { OfficeActionError } from '.'

export class OfficeDisplayDialogPopupBlockedError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogPopupBlockedError'
  readonly name = 'Display Dialog Popup Blocked Error'
  readonly code = 12011
  constructor() {
    super(
      'The operation failed because a popup blocker is preventing the dialog from being displayed.'
    )
  }
}

export class OfficeDisplayDialogError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogError'
  readonly name = 'Display Dialog Error'
  readonly code = 12007

  constructor() {
    super(
      'The operation failed because this add-in already has an active dialog.'
    )
  }
}

export class OfficeDisplayDialogDeniedError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogDeniedError'
  readonly name = 'Display Dialog Denied Error'
  readonly code = 12009

  constructor() {
    super(
      'The operation failed because the user denied permission to display the dialog.'
    )
  }
}

export class OfficeDialogUrlError extends OfficeActionError {
  readonly _tag = 'OfficeDialogUrlError'
  readonly name = 'Dialog Navigation Error'
  readonly code = 12003

  constructor() {
    super('The URL scheme is not supported. Use HTTPS instead.')
  }
}

export class OfficeDisplayDialogUntrustedUrlError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogUntrustedUrlError'
  readonly name = 'Display Dialog Untrusted URL Error'
  readonly code = 12004
  constructor() {
    super(
      'Untrusted URL. The domain of the URL is not trusted for this add-in.'
    )
  }
}

export class OfficeDisplayDialogUntrustedUrlError2 extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogUntrustedUrlError'
  readonly name = 'Display Dialog Untrusted URL Error'
  readonly code = 12005
  constructor() {
    super(
      'Untrusted URL. The domain of the URL is not trusted for this add-in.'
    )
  }
}

export class OfficeDisplayDialogAlreadyCloseError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogAlreadyCloseError'
  readonly name = 'Display Dialog Already Closed Error'
  readonly code = 12006
  constructor() {
    super('The dialog has already been closed.')
  }
}

export class OfficeDisplayDialogUnknownError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogUnknownError'
  readonly name = 'Display Dialog Unknown Error'
  readonly code = 120111
  constructor() {
    super('An unknown error occurred when displaying dialog.')
  }
}

export class OfficeDisplayDialogFailedToLoadPageError extends OfficeActionError {
  readonly _tag = 'OfficeDisplayDialogFailedToLoadPageError'
  readonly name = 'Display Dialog Failed To Load Page Error'
  readonly code = 12002

  constructor() {
    super('The dialog failed to load the requested page.')
  }
}
